export default __webpack_public_path__ + "justhatched-third-screens@2x.13e2bb96.png";